<div class="dot-loader">
  <span></span>
  <span></span>
  <span></span>
  <span></span>
  <span></span>
</div>
